export default function formatTags(tags = []) {
  return tags.map((tag) => ({
    id: tag.id,
    link: `/blog/tag/${tag.slug}`,
    redirect: `/blog/1?tags=${tag.id}&slug=${tag.slug}`,
    slug: tag.slug,
    name: tag.name,
  }));
}
